import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";

import es_json from "@/locale/es.json";
import en_json from "@/locale/en.json";
import fr_json from "@/locale/fr.json";

import es_data from "@/remote/get_data_es.json";
import en_data from "@/remote/get_data_en.json";
import fr_data from "@/remote/get_data_fr.json";

require("@/scss/main.css");

var VueScrollTo = require("vue-scrollto");

Vue.config.productionTip = false;
Vue.use(VueScrollTo);

router.beforeEach((to, from, next) => {
	// Validation
	if (to.name == "protected") {
		if ((from.name == "activate" || from.name == "config") && vm.validated) {
			next();
		} else {
			next({ name: "activate", replace: true });
		}
	} else {
		next();
	}
});

var vm = new Vue({
	router,
	data() {
		return {
			language_selected: 0,
			floor_selected: 0,
			audio_selected: -1,
			languages: [{ json: es_json }, { json: en_json }, { json: fr_json }],
			audios: [{ json: es_data }, { json: en_data }, { json: fr_data }]
		};
	},
	computed: {
		texts: function() {
			return this.languages[this.language_selected].json;
		},
		list: function() {
			return this.audios[this.language_selected].json;
		},
		media: function() {
			return this.audios[this.language_selected].json[this.floor_selected]
				.media;
		}
	},
	methods: {
		changeLanguage: function(n) {
			this.language_selected = n;
		},
		changeFloorSelection: function(n) {
			this.audio_selected = -1;
			this.floor_selected = n;
		}
	},
	render: h => h(App)
}).$mount("#app");
